const title = "我是测试"

export default function getPageTitle(pageTitle) {
    if (pageTitle) {
        return pageTitle
    }
    return title
}


// WEBPACK FOOTER //
// src/api/get-page-title.js